import { render, staticRenderFns } from "./BRadioButton.vue?vue&type=template&id=fa638d0c&scoped=true"
import script from "./BRadioButton.vue?vue&type=script&lang=ts"
export * from "./BRadioButton.vue?vue&type=script&lang=ts"
import style0 from "./BRadioButton.vue?vue&type=style&index=0&id=fa638d0c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa638d0c",
  null
  
)

export default component.exports